import { render } from "./IconRotate.vue?vue&type=template&id=52414da0"
const script = {}
script.render = render

export default script